import { useEffect } from "react";

import { env } from "@/config/env";
import {
  getAttributionCookie,
  getPriceVariantCookie,
} from "@/shared/lib/attribution-cookie";
import {
  initializeMouseflow,
  removeMouseflow,
  setMouseflowVariable,
} from "@/shared/lib/mouseflow/script";

const NO_PRICE_VARIANT = "default";

export const useMouseflowSession = () => {
  useEffect(() => {
    if (!env.VITE_MOUSEFLOW_SITE_ID) {
      return;
    }

    initializeMouseflow(window, document, env.VITE_MOUSEFLOW_SITE_ID);

    const attribution = getAttributionCookie();
    if (attribution?.affid) {
      setMouseflowVariable(window, "affiliate_id", attribution.affid);
    }
    if (attribution?.oid) {
      setMouseflowVariable(window, "oid", attribution.oid);
    }
    setMouseflowVariable(
      window,
      "price_variant",
      getPriceVariantCookie() ?? NO_PRICE_VARIANT,
    );

    return () => {
      removeMouseflow(window, document);
    };
  }, []);
};
